import React from "react"
import { Tabs, TabList, Tab, Text, TabPanels, TabIndicator, TabPanel } from "@chakra-ui/react"
import MClothingPanel from "./MClothingPanel"
import MAccessoriesPanel from "./MAccessoriesPanel"
import MShoesPanel from "./MShoesPanel"
import MUnderwearPanel from "./MUnderwearPanel"

const MenTab: React.FC = () => {
  return (
    <Tabs>
      <TabList color='gray.500'>
        <Tab _selected={{ color: '#37A75B' }}>
          <Text fontSize={['xs', 'md']} fontWeight='semibold'>
            Men's clothing
          </Text>
        </Tab>

        <Tab _selected={{ color: '#37A75B' }}>
          <Text fontSize={['xs', 'md']} fontWeight='semibold'>
            Men's shoes
          </Text>
        </Tab>

        <Tab _selected={{ color: '#37A75B' }}>
          <Text fontSize={['xs', 'md']} fontWeight='semibold'>
            Men's accessories
          </Text>
        </Tab>

        <Tab _selected={{ color: '#37A75B' }}>
          <Text fontSize={['xs', 'md']} fontWeight='semibold'>
            Men's underwears
          </Text>
        </Tab>
      </TabList>

      <TabIndicator
        mt="-1.5px"
        height="2px"
        bg="#37A75B"
        borderRadius="1px"
      />

      <TabPanels>
        <TabPanel p={0}>
          <MClothingPanel />
        </TabPanel>

        <TabPanel p={0}>
          <MShoesPanel />
        </TabPanel>

        <TabPanel p={0}>
          <MAccessoriesPanel />
        </TabPanel>

        <TabPanel p={0}>
          <MUnderwearPanel />
        </TabPanel>
      </TabPanels>
    </Tabs>
  )
}

export default MenTab